import React__default from 'react';
import { toast } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';
import CustomerSupportFormContainer from './CustomerSupportForm/CustomerSupportFormContainer.js';
import SuccessMessageContainer from './SuccessMessage/SuccessMessageContainer.js';

const CustomerSupport = ({ onSubmit , isLoading , showErrorMessage =false , showSuccessMessage =false , isCustomerIDActivated =false , showConsent =false ,  })=>{
    React__default.useEffect(()=>{
        if (showErrorMessage) {
            toast.failed('customersupport.submit.error');
        }
    }, [
        showErrorMessage
    ]);
    return /*#__PURE__*/ React__default.createElement("section", {
        className: "customer-support",
        "data-t": "customer-support"
    }, /*#__PURE__*/ React__default.createElement(Container, {
        className: "customer-support__container"
    }, showSuccessMessage ? /*#__PURE__*/ React__default.createElement(SuccessMessageContainer, null) : /*#__PURE__*/ React__default.createElement(CustomerSupportFormContainer, {
        onSubmit: onSubmit,
        isLoading: isLoading,
        isCustomerIDActivated: isCustomerIDActivated,
        showConsent: showConsent
    })));
};
var CustomerSupport$1 = CustomerSupport;

export { CustomerSupport$1 as default };
//# sourceMappingURL=CustomerSupport.js.map
